"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var react_apollo_1 = require("react-apollo");
var convert_currency_1 = require("@reverbdotcom/commons/dist/convert_currency");
var offer_operations_1 = require("@reverbdotcom/commons/dist/offers/offer_operations");
var negotiation_summary_1 = require("./negotiation_summary");
var update_offer_form_fields_1 = require("./update_offer_form_fields");
var offer_calculator_1 = require("@reverbdotcom/commons/dist/offers/offer_calculator");
var url_helpers_1 = require("../shared/url_helpers");
var bind_1 = require("../../bind");
var rql_1 = require("../../schemas/rql");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var modal_1 = require("@reverbdotcom/commons/dist/components/modal");
var offer_listing_sidebar_1 = require("@reverbdotcom/commons/dist/offers/offer_listing_sidebar");
var lodash_1 = require("lodash");
var negotiation_getters_1 = require("./negotiation_getters");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var TRACKING_COMPONENT = 'UpdateOfferModal';
var UpdateOfferModal = /** @class */ (function (_super) {
    tslib_1.__extends(UpdateOfferModal, _super);
    function UpdateOfferModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            error: '',
            isFormSaving: false,
            offer: {
                price: '',
                message: '',
                quantity: null,
            },
        };
        return _this;
    }
    UpdateOfferModal.prototype.componentDidUpdate = function (prevProps) {
        if (lodash_1.isEmpty(lodash_1.get(prevProps, 'data.listing')) && !lodash_1.isEmpty(lodash_1.get(this.props, 'data.listing'))) {
            this.trackView();
        }
    };
    Object.defineProperty(UpdateOfferModal.prototype, "trackingContext", {
        get: function () {
            return {
                listingId: this.props.listingId,
                negotiationId: this.props.negotiationId,
                shopCurrency: this.props.data.listing.shop.currency,
                userCurrency: this.userCurrency,
            };
        },
        enumerable: true,
        configurable: true
    });
    UpdateOfferModal.prototype.trackView = function () {
        tracker_1.trackView({
            componentName: TRACKING_COMPONENT,
            ids: [this.props.listingId],
            type: tracker_1.LISTING_TYPE,
            context: this.trackingContext,
        });
    };
    Object.defineProperty(UpdateOfferModal.prototype, "isLoading", {
        get: function () {
            return lodash_1.get(this.props, 'data.loading');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferModal.prototype, "isInitializing", {
        get: function () {
            var listingIsNotLoaded = !lodash_1.get(this.props, 'data.listing');
            return this.isLoading && listingIsNotLoaded;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferModal.prototype, "offerError", {
        get: function () {
            return lodash_1.get(this.props, 'data.error.message');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferModal.prototype, "inputOffer", {
        get: function () {
            var shippingPrice = negotiation_getters_1.offerShippingPriceAmount(this.state.offer.shippingPrice, lodash_1.get(this.props.data, 'me'));
            var quantity = negotiation_getters_1.offerQuantity(this.lastOffer, this.state.offer.quantity);
            return {
                quantity: quantity,
                shippingPrice: shippingPrice,
                price: this.state.offer.price,
                message: this.state.offer.message,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferModal.prototype, "existingOffer", {
        get: function () {
            return {
                price: this.lastOffer.prices.price.display.amount,
                shippingPrice: this.lastOffer.prices.shippingPrice.display.amount,
                quantity: lodash_1.first(this.lastOffer.offerItems).quantity,
                message: this.state.offer.message,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferModal.prototype, "offerToSubmitOnUpdate", {
        get: function () {
            var baseOffer = this.isCounterOffer ? this.inputOffer : this.existingOffer;
            var shopCurrencyOfferPrice = convert_currency_1.convertCurrency(this.userCurrency, negotiation_getters_1.originalCurrency(this.props.data), this.exchangeRates, baseOffer.price);
            var shopCurrencyOfferShippingPrice = convert_currency_1.convertCurrency(this.userCurrency, negotiation_getters_1.originalCurrency(this.props.data), this.exchangeRates, baseOffer.shippingPrice);
            return {
                action: this.props.negotiationAction,
                id: this.negotiation.id,
                message: this.state.offer.message,
                offerItems: [
                    {
                        listingId: this.props.data.listing.id,
                        quantity: baseOffer.quantity,
                        price: shopCurrencyOfferPrice,
                        shippingPrice: shopCurrencyOfferShippingPrice,
                    },
                ],
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferModal.prototype, "negotiation", {
        get: function () {
            return negotiation_getters_1.activeNegotiation(lodash_1.get(this.props.data, 'me'));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferModal.prototype, "lastOffer", {
        get: function () {
            return negotiation_getters_1.lastOffer(this.negotiation);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferModal.prototype, "isCounterOffer", {
        get: function () {
            return this.props.negotiationAction === rql_1.core_apimessages_NegotiationAction.COUNTER;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferModal.prototype, "party", {
        get: function () {
            return this.props.isSeller ? rql_1.core_apimessages_NegotiationParty.SELLER : rql_1.core_apimessages_NegotiationParty.BUYER;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferModal.prototype, "exchangeRates", {
        get: function () {
            return lodash_1.get(this.props, 'data.exchangeRates.rates', []);
        },
        enumerable: true,
        configurable: true
    });
    UpdateOfferModal.prototype.updateNegotiation = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var input;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        input = this.offerToSubmitOnUpdate;
                        return [4 /*yield*/, this.props.updateNegotiation({ variables: { input: input } })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, lodash_1.first(input.offerItems)];
                }
            });
        });
    };
    UpdateOfferModal.prototype.notifySuccess = function () {
        this.props.onSuccess(this.party);
    };
    UpdateOfferModal.prototype.closeDialog = function () {
        if (this.props.onRequestDialogClose) {
            this.props.onRequestDialogClose();
        }
    };
    UpdateOfferModal.prototype.handleSubmit = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var submittedOffer, errors_1, message;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.setState({ isFormSaving: true, error: null });
                        return [4 /*yield*/, this.updateNegotiation()];
                    case 2:
                        submittedOffer = _a.sent();
                        this.setState({ isFormSaving: false });
                        tracker_1.trackInteraction({
                            componentName: TRACKING_COMPONENT,
                            entityId: this.props.listingId,
                            type: tracker_1.LISTING_TYPE,
                            interactionType: tracker_1.SUBMIT,
                            context: tslib_1.__assign(tslib_1.__assign({}, this.trackingContext), { offer: submittedOffer }),
                        });
                        this.notifySuccess();
                        this.closeDialog();
                        return [3 /*break*/, 4];
                    case 3:
                        errors_1 = _a.sent();
                        message = lodash_1.first(lodash_1.get(errors_1, 'graphQLErrors', [{ message: '' }])).message;
                        this.setState({ error: message, isFormSaving: false });
                        tracker_1.trackError({
                            error: message,
                            name: TRACKING_COMPONENT,
                            context: this.trackingContext,
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UpdateOfferModal.prototype.handleOfferChange = function (offer) {
        this.setState({
            offer: tslib_1.__assign(tslib_1.__assign({}, this.state.offer), offer),
        });
    };
    UpdateOfferModal.prototype.renderOfferSidebar = function () {
        var listing = lodash_1.get(this.props, 'data.listing');
        return (React.createElement(offer_listing_sidebar_1.OfferListingSidebar, { listing: listing, isLoading: this.isLoading, isSeller: this.props.isSeller, listingUrlGenerator: url_helpers_1.default.listingPagePath }));
    };
    UpdateOfferModal.prototype.showError = function () {
        var noNegotiationFound = (!this.negotiation && !this.isLoading);
        var missingExchangeRates = !this.props.data.exchangeRates &&
            !this.props.isSeller &&
            (this.userCurrency !== negotiation_getters_1.originalCurrency(this.props.data));
        return lodash_1.get(this.props, 'data.error') || noNegotiationFound || missingExchangeRates;
    };
    UpdateOfferModal.prototype.renderOffersForm = function () {
        if (this.showError()) {
            return (React.createElement("div", { className: "alert-box alert-box--red" },
                React.createElement("p", { className: "mb-0" }, I18n.t('discovery.offers.error'))));
        }
        if (this.isInitializing) {
            return (React.createElement("div", { className: "offers-form offers-form--loading" },
                React.createElement("div", { className: "offers-form-placeholder" }),
                React.createElement("div", { className: "offers-form-placeholder" }),
                React.createElement("div", { className: "offers-form-placeholder" })));
        }
        return (React.createElement("form", { className: "offers-form", onSubmit: this.handleSubmit },
            React.createElement("div", { className: "offers-form__header" },
                React.createElement(negotiation_summary_1.default, { prices: this.lastOfferPrices, originalPrices: this.originalLastOfferPrices, listing: this.props.data.listing, negotiation: this.negotiation, party: this.party })),
            React.createElement(update_offer_form_fields_1.default, { error: this.state.error, listing: this.props.data.listing, negotiation: this.negotiation, currency: this.userCurrency, exchangeRates: this.exchangeRates, offer: this.inputOffer, onOfferChange: this.handleOfferChange, action: this.props.negotiationAction, party: this.party }),
            React.createElement("div", { className: "offers-form__actions" },
                React.createElement("button", { className: "offers-form__actions__save", type: "submit", disabled: this.disableSaveButton }, this.saveButtonText),
                React.createElement("button", { className: "offers-form__actions__back", onClick: this.closeDialog }, I18n.t('commons.offers.backAction')))));
    };
    Object.defineProperty(UpdateOfferModal.prototype, "modalHeaderTitle", {
        get: function () {
            var action = this.props.negotiationAction.toLocaleLowerCase();
            return I18n.t("discovery.offers.headerTitle." + action);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferModal.prototype, "disableSaveButton", {
        get: function () {
            return this.state.isFormSaving || (this.isCounterOffer && !this.state.offer.price);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferModal.prototype, "counterOfferSubmitButtonText", {
        get: function () {
            if (!this.state.offer.price) {
                return I18n.t('discovery.offers.submitButton.counter.loading');
            }
            return I18n.t('discovery.offers.submitButton.counter.counterOfferForAmount', {
                offerTotal: offer_calculator_1.offerTotal(this.inputOffer, this.userCurrency).display,
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferModal.prototype, "saveButtonText", {
        get: function () {
            switch (this.props.negotiationAction) {
                case rql_1.core_apimessages_NegotiationAction.ACCEPT:
                    return I18n.t('discovery.offers.headerTitle.accept');
                case rql_1.core_apimessages_NegotiationAction.REJECT:
                    return I18n.t('discovery.offers.headerTitle.reject');
                case rql_1.core_apimessages_NegotiationAction.COUNTER:
                default:
                    return this.counterOfferSubmitButtonText;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferModal.prototype, "userCurrency", {
        get: function () {
            return negotiation_getters_1.userCurrency(this.props.data, this.props.user);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferModal.prototype, "lastOfferPrices", {
        get: function () {
            return negotiation_getters_1.lastOfferPrices(lodash_1.get(this.props.data, 'me'));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferModal.prototype, "originalLastOfferPrices", {
        get: function () {
            return negotiation_getters_1.lastOfferPricesFor(rql_1.core_apimessages_NegotiationParty.SELLER, this.negotiation);
        },
        enumerable: true,
        configurable: true
    });
    UpdateOfferModal.prototype.render = function () {
        if (!this.props.data) {
            return null;
        }
        return (React.createElement(modal_1.default, { isOpen: this.props.isDialogOpen, onRequestClose: this.closeDialog, headerTitle: this.modalHeaderTitle, sidebarContent: this.renderOfferSidebar(), paddedBody: true, newClose: true }, this.renderOffersForm()));
    };
    tslib_1.__decorate([
        bind_1.default
    ], UpdateOfferModal.prototype, "updateNegotiation", null);
    tslib_1.__decorate([
        bind_1.default
    ], UpdateOfferModal.prototype, "closeDialog", null);
    tslib_1.__decorate([
        bind_1.default
    ], UpdateOfferModal.prototype, "handleSubmit", null);
    tslib_1.__decorate([
        bind_1.default
    ], UpdateOfferModal.prototype, "handleOfferChange", null);
    return UpdateOfferModal;
}(React.Component));
exports.UpdateOfferModal = UpdateOfferModal;
var connectOfferModal = react_apollo_1.compose(offer_operations_1.connectEditOfferFormQuery, offer_operations_1.connectUpdateNegotiationMutation)(UpdateOfferModal);
exports.default = user_context_provider_1.withUserContext(connectOfferModal);
//# sourceMappingURL=update_offer_modal.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/offers/update_offer_modal.js
// module id = SNIh
// module chunks = 20 21